import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugLogActions } from "../helpers/debugHelper";

export const previewRoleFlowBatchAssignments = async (payload = {}) => {
  const resp = await fetchToken(
    `${const_routes.SCHEMA}`,
    `${const_routes.VERSIONV1}`,
    `${const_routes.ROUTE_ROLE_FLOW}`,
    "preview-batch",
    payload,
    "POST"
  );
  const body = await resp.json();
  if (body.ok) {
    return body.previews || [];
  }
  return [];
};

export const roleFlowStartRegister = (roleFlow) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_ROLE_FLOW}`,
        "add",
        roleFlow,
        "POST"
      );

      const body = await resp.json();

      debugLogActions(':: roleFlowActions, roleFlowStartRegister', { 'body': body });

      if (body.ok) {
        dispatch(roleFlowRegister(body.roleFlow));
        return {
          ok: true,
          roleFlow: body.roleFlow,
          roleFlows: body.roleFlows,
          assignmentResults: body.assignmentResults || []
        };
      }

      handleRoleFlowError(body, dispatch);
      return { ok: false, msg: body.msg || '' };
    } catch (error) {
      debugLogActions(':: roleFlowActions, roleFlowStartRegister catch', { error });
      handleRoleFlowError({ msg: error?.message || '' }, dispatch);
      return { ok: false, msg: error?.message || '' };
    }
  }
};

const roleFlowRegister = (roleFlow) => ({
  type: types.ROLEFLOW_START_REGISTER,
  payload: roleFlow,
});

const roleFlowSetLoading = (isLoading) => ({
  type: types.ROLEFLOW_SET_LOADING,
  payload: isLoading
});

const roleFlowSetTimeline = (timeline) => ({
  type: types.ROLEFLOW_SET_TIMELINE,
  payload: timeline
});

const handleRoleFlowError = (body, dispatch) => {
  if (body.code === "flow-pool-operate-denied" || body.code === "flow-pool-role-required" || body.code === "flow-pool-role-not-assigned") {
    Swal.fire(
      t("titles.error"),
      body.msg || t("flow.pool.operate-denied", "El rol activo no puede operar esta bandeja."),
      "warning"
    );
    return;
  }
  if (body.code === "flow-engine-disabled") {
    Swal.fire(
      t("titles.error"),
      t("general.flow-engine.disabled-global", "El motor de flujos está desactivado."),
      "warning"
    );
    return;
  }
  if (body.code === "bak-aut-tok-inv-001") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
    return;
  }
  if (body.code === "bak-aut-tok-inv-002") {
    Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
    dispatch(startLogout());
    return;
  }
  Swal.fire(
    t("titles.error"),
    body.msg || `${t("alerts.validation.bak-error-001")} - ${body.method || "addRoleFlow"}`,
    "error"
  );
};

const resolveRoleFlowPayload = (body) => {
  if (Array.isArray(body?.roleFlows)) {
    return body.roleFlows;
  }
  if (Array.isArray(body)) {
    return body;
  }
  return [body?.roleFlow].filter(Boolean);
};

export const roleFlowStartLoadingByModuleAndReference = (module_id, reference_id) => {
  return async (dispatch) => {
    dispatch(roleFlowSetLoading(true));
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_ROLE_FLOW}`,
        `getByModuleAndReference/${module_id}/${reference_id}`
      );

      const body = await resp.json();
      debugLogActions(":: roleFlowActions, roleFlowStartLoadingByModuleAndReference", { body });

      if (body.ok) {
        const roleFlows = resolveRoleFlowPayload(body);
        dispatch(roleFlowLoading(roleFlows));

        const firstTimeline = roleFlows[0]?.RoleFlow_To_FlowHistory || [];
        dispatch(roleFlowSetTimeline(firstTimeline));
      } else {
        handleRoleFlowError(body, dispatch);
      }
    } catch (error) {
      debugLogActions(":: roleFlowActions, roleFlowStartLoadingByModuleAndReference - error", { error });
    } finally {
      dispatch(roleFlowSetLoading(false));
    }
  };
};

const roleFlowLoading = (payload) => ({
  type: types.ROLEFLOW_START_LOADING,
  payload,
});